import SignIn from './SignIn';
import AdminLogin from './adminLogin';
import TenantSignIn from './Tenant-Signin';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import UserCommonInfos from './UserCommonInfos';

export { SignIn, ForgotPassword, ResetPassword, UserCommonInfos, TenantSignIn, AdminLogin };



// WEBPACK FOOTER //
// ./src/modules/auth/components/index.js